import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="legal-page">
            <div className="legal-hero section-padding">
                <div className="container">
                    <h1 className="legal-title">Privacy Policy</h1>
                    <p className="legal-subtitle">Last updated: December 2025</p>
                </div>
            </div>

            <div className="container">
                <div className="legal-content">
                    <section className="legal-section">
                        <h2>Introduction</h2>
                        <p>
                            Vintage Glass Works ("we," "our," or "us") respects your privacy and is committed
                            to protecting your personal data. This privacy policy explains how we collect, use,
                            disclose, and safeguard your information when you visit our website or use our services.
                        </p>
                        <p>
                            Please read this privacy policy carefully. If you do not agree with the terms of this
                            privacy policy, please do not access the site.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Information We Collect</h2>

                        <h3>Personal Data</h3>
                        <p>We may collect personal information that you voluntarily provide to us when you:</p>
                        <ul>
                            <li>Fill out our contact form</li>
                            <li>Request a consultation or quote</li>
                            <li>Subscribe to our newsletter</li>
                            <li>Communicate with us via email or phone</li>
                        </ul>
                        <p>This information may include:</p>
                        <ul>
                            <li>Name</li>
                            <li>Email address</li>
                            <li>Phone number</li>
                            <li>Mailing address</li>
                            <li>Project details and descriptions</li>
                        </ul>

                        <h3>Automatically Collected Information</h3>
                        <p>
                            When you visit our website, we may automatically collect certain information about
                            your device, including:
                        </p>
                        <ul>
                            <li>IP address</li>
                            <li>Browser type and version</li>
                            <li>Operating system</li>
                            <li>Pages visited and time spent on pages</li>
                            <li>Referring website addresses</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>How We Use Your Information</h2>
                        <p>We use the information we collect to:</p>
                        <ul>
                            <li>Respond to your inquiries and provide customer service</li>
                            <li>Provide quotes and consultations for restoration projects</li>
                            <li>Send you information about our services (with your consent)</li>
                            <li>Improve our website and services</li>
                            <li>Comply with legal obligations</li>
                            <li>Protect against fraudulent or illegal activity</li>
                        </ul>
                    </section>

                    <section className="legal-section">
                        <h2>Disclosure of Your Information</h2>
                        <p>We may share your information in the following situations:</p>
                        <ul>
                            <li>
                                <strong>Service Providers:</strong> We may share your information with third-party
                                vendors who perform services on our behalf, such as email delivery and website hosting.
                            </li>
                            <li>
                                <strong>Legal Requirements:</strong> We may disclose your information where required
                                by law or in response to valid legal requests.
                            </li>
                            <li>
                                <strong>Business Transfers:</strong> In connection with any merger, sale of company
                                assets, or acquisition, your information may be transferred.
                            </li>
                        </ul>
                        <p>
                            We do not sell, rent, or trade your personal information to third parties for
                            marketing purposes.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Cookies and Tracking Technologies</h2>
                        <p>
                            We may use cookies and similar tracking technologies to track activity on our website
                            and hold certain information. Cookies are files with a small amount of data that may
                            include an anonymous unique identifier.
                        </p>
                        <p>You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our website.</p>
                    </section>

                    <section className="legal-section">
                        <h2>Data Security</h2>
                        <p>
                            We implement appropriate technical and organizational security measures to protect
                            your personal information against unauthorized access, alteration, disclosure, or
                            destruction. However, no method of transmission over the Internet or electronic
                            storage is 100% secure, and we cannot guarantee absolute security.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Data Retention</h2>
                        <p>
                            We retain your personal information only for as long as necessary to fulfill the
                            purposes for which it was collected, including to satisfy legal, accounting, or
                            reporting requirements. Project records may be retained for up to seven years for
                            warranty and reference purposes.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Your Privacy Rights</h2>
                        <p>Depending on your location, you may have the following rights regarding your personal data:</p>
                        <ul>
                            <li>The right to access your personal information</li>
                            <li>The right to correct inaccurate information</li>
                            <li>The right to request deletion of your information</li>
                            <li>The right to opt-out of marketing communications</li>
                            <li>The right to data portability</li>
                        </ul>
                        <p>
                            To exercise any of these rights, please contact us using the information provided below.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Third-Party Links</h2>
                        <p>
                            Our website may contain links to third-party websites. We are not responsible for
                            the privacy practices or content of these external sites. We encourage you to review
                            the privacy policies of any third-party sites you visit.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Children's Privacy</h2>
                        <p>
                            Our website is not intended for children under 13 years of age. We do not knowingly
                            collect personal information from children under 13. If you are a parent or guardian
                            and believe your child has provided us with personal information, please contact us.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Changes to This Privacy Policy</h2>
                        <p>
                            We may update this privacy policy from time to time. We will notify you of any changes
                            by posting the new privacy policy on this page and updating the "Last updated" date.
                            You are advised to review this privacy policy periodically for any changes.
                        </p>
                    </section>

                    <section className="legal-section">
                        <h2>Contact Us</h2>
                        <p>If you have questions about this Privacy Policy or our privacy practices, please contact us:</p>
                        <div className="legal-contact">
                            <p><strong>Vintage Glass Works</strong></p>
                            <p>Email: info@vintageglassworks.com</p>
                            <p>Phone: (207) 588-7000</p>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;